import CheckboxGroup from './src'

CheckboxGroup.install = Vue => {
  Vue.component(CheckboxGroup.name, CheckboxGroup)
}

export default CheckboxGroup
